import React, { useState } from "react";
import "./feedback.css";
import { apiClient } from "../../services/api/apiService";

const CATEGORIES = ["Bug Report", "Feature Request", "Feedback", "Other"];

export default function FeedbackButton() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ email: "", type: "Feedback", subject: "", message: "" });
  const [status, setStatus] = useState(""); // "" | "sending" | "sent" | "error"
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setErrorMsg("");
    try {
      // apiClient targets the backend (REACT_APP_API_URL) and adds the CSRF token;
      // a relative fetch("/api/feedback") would hit the Vercel frontend instead.
      const { data } = await apiClient.post("/feedback", form);
      if (data.success) {
        setStatus("sent");
        setForm({ email: "", type: "Feedback", subject: "", message: "" });
      } else {
        setStatus("error");
        setErrorMsg(data.message || "Something went wrong.");
      }
    } catch (err) {
      setStatus("error");
      setErrorMsg(err.response?.data?.message || "Network error. Please try again.");
    }
  };

  const handleClose = () => {
    setOpen(false);
    if (status === "sent") setStatus("");
  };

  return (
    <>
      {/* Floating trigger button */}
      <button
        className="fb-trigger"
        onClick={() => setOpen((o) => !o)}
        aria-label="Send feedback or report a bug"
        title="Feedback / Bug Report"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
        <span className="fb-trigger-label">Feedback</span>
      </button>

      {/* Overlay + Modal */}
      {open && (
        <>
          <div className="fb-overlay" onClick={handleClose} aria-hidden="true" />
          <div className="fb-modal" role="dialog" aria-modal="true" aria-label="Feedback form">
            <div className="fb-modal-header">
              <h3 className="fb-modal-title">💬 Share your feedback</h3>
              <button className="fb-close" onClick={handleClose} aria-label="Close">✕</button>
            </div>

            {status === "sent" ? (
              <div className="fb-sent">
                <div className="fb-sent-icon">✅</div>
                <p className="fb-sent-title">Thank you!</p>
                <p className="fb-sent-body">We've received your message and will get back to you soon.</p>
                <button className="fb-submit" onClick={handleClose}>Close</button>
              </div>
            ) : (
              <form className="fb-form" onSubmit={handleSubmit} noValidate>
                <div className="fb-field">
                  <label htmlFor="fb-email">Your email *</label>
                  <input
                    id="fb-email"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="you@example.com"
                    required
                    disabled={status === "sending"}
                  />
                </div>

                <div className="fb-field fb-row">
                  <div style={{ flex: 1 }}>
                    <label htmlFor="fb-type">Category</label>
                    <select
                      id="fb-type"
                      name="type"
                      value={form.type}
                      onChange={handleChange}
                      disabled={status === "sending"}
                    >
                      {CATEGORIES.map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="fb-field">
                  <label htmlFor="fb-subject">Subject</label>
                  <input
                    id="fb-subject"
                    name="subject"
                    type="text"
                    value={form.subject}
                    onChange={handleChange}
                    placeholder="Brief description"
                    maxLength={120}
                    disabled={status === "sending"}
                  />
                </div>

                <div className="fb-field">
                  <label htmlFor="fb-message">Message *</label>
                  <textarea
                    id="fb-message"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Describe the issue or your idea in detail..."
                    rows={5}
                    required
                    minLength={10}
                    maxLength={2000}
                    disabled={status === "sending"}
                  />
                  <small className="fb-char-count">{form.message.length}/2000</small>
                </div>

                {status === "error" && (
                  <p className="fb-error">{errorMsg}</p>
                )}

                <button
                  type="submit"
                  className="fb-submit"
                  disabled={status === "sending"}
                >
                  {status === "sending" ? "Sending…" : "Send Message"}
                </button>
              </form>
            )}

            <p className="fb-footer-note">
              or email directly:{" "}
              <a href="mailto:hello@sportifide.com">hello@sportifide.com</a>
            </p>
          </div>
        </>
      )}
    </>
  );
}
